export default __webpack_public_path__ + "static/media/MarketRealCase2.a813974e.jpg";